import { Injectable } from "@angular/core"
import { CanActivate } from "@angular/router"

import { Observable } from "rxjs"
import { Route } from "@angular/compiler/src/core"
import { environment } from "src/environments/environment"
import { Store } from "@ngrx/store"
import { State } from "src/app/store/reducers"
import { loginRequest } from "src/app/auth/store/auth.actions"
import { LoginRequest } from "src/app/auth/models/login-request"
import * as Utils from "../auth/lib/utils"
import { HelpersService } from "../services/helpers.service"

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private store: Store<State>,
		private helpersService: HelpersService
	) {}

	canActivate(route: Route): Observable<boolean> | boolean {
		const urlParams = new URLSearchParams(window.location.search)
		const token = urlParams.get("auth_token")
		const isLogged = Utils.accessToken
		if (isLogged) {
			return true
		} else {
			if (token) {
				const request = new LoginRequest({ token })
				this.store.dispatch(loginRequest({ request }))
				return true
			} else {
				window.location.replace(
					`${environment.DOMAIN_URL}/api2/saml/login?redirect_uri=${environment.redirectSSOUrl}`
				)
				return false
			}
		}
	}
}
